export enum TradeDirection {
  Buy = 0,
  Sell = 1,
}
